import { FC } from 'react';

import { styled } from '@mui/material';
import TooltipBase from '@mui/material/Tooltip';
import clsx from 'clsx';

import { StyledTooltipProps, TooltipProps } from './types';

import styles from './styles.module.scss';

import TooltipIcon from '@/assets/icons/help.svg?react';

const TooltipBaseStyled = styled(({ className, ...props }: StyledTooltipProps) => (
  <TooltipBase {...props} classes={{ popper: className }} />
))`
  & .MuiTooltip-tooltip {
    font-size: 12px;
    line-height: 1.5;
    padding: 8px 12px;
    z-index: 100000;
    max-width: 320px;
    background-color: #282828;
    color: white;
    font-family: 'Open Sans', sans-serif;
  }
  & .MuiTooltip-arrow {
    color: #282828;
    z-index: 100000;
  }
`;

export const Tooltip: FC<TooltipProps> = ({ customElement, elementClassName, placement = 'top', ...tooltipProps }) => {
  return (
    <TooltipBaseStyled {...tooltipProps} placement={placement} arrow>
      {customElement || <TooltipIcon className={clsx(styles.icon, elementClassName)} />}
    </TooltipBaseStyled>
  );
};
